import { formatFilterV2ToApiFormat } from "PFApp/components/filters_v2";
import { CalendarRange, Id } from "PFTypes";
import { FiltersV2 } from "PFTypes/filters_v2";

import { PER_PAGE, RequestData } from "./get_request_data";

export const getProfilesLinkedToEngagementAndNestedRolesRequest = (
  activityId: Id,
  dateRange: CalendarRange,
  rolesFilters: FiltersV2 = {}
): RequestData => ({
  url: "booking_module/engagement_profiles/index",
  data: {
    perPage: PER_PAGE,
    activityId,
    dateRange,
    filters: formatFilterV2ToApiFormat(rolesFilters)
  },
  childrenType: "profile",
  options: { method: "POST" }
});
